import { render, staticRenderFns } from "./upRecord.vue?vue&type=template&id=3336e182&scoped=true&"
import script from "./upRecord.vue?vue&type=script&lang=js&"
export * from "./upRecord.vue?vue&type=script&lang=js&"
import style0 from "./upRecord.vue?vue&type=style&index=0&id=3336e182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3336e182",
  null
  
)

export default component.exports